export const FETCH_SHIFT_CATEGORIES = "fetch_shift_categories";
export const FETCH_SHIFT_CATEGORIES_SUCCESS = "fetch_shift_categories_success";
export const SHIFT_CATEGORY_NAME = "shift_category_name";
export const SHIFT_CATEGORY_ORDER = "shift_category_order";
export const SHIFT_CATEGORY_SHIFT_TYPE = "shift_category_shift_type";
export const SHIFT_CATEGORY_DESCRIPTION = "shift_category_description";
export const SHIFT_CATEGORY_SUBMIT_FORM = "shift_category_submit_form";
export const SHIFT_CATEGORY_ACTION_SUCCESS = "shift_category_create_edit_success";
export const SHIFT_CATEGORY_EDIT = "shift_category_edit";
export const SHIFT_CATEGORY_EDIT_SUBMIT_FORM = "shift_category_edit_submit_form";
export const SHIFT_CATEGORY_DELETE = "shift_category_delete";
export const SHIFT_CATEGORY_DIALOG_BOX_STATUS = "shift_category_dialog_box_status";
export const SHIFT_CATEGORY_SET_DELETE_ID = "shift_category_set_delete_id";
export const GET_SHIFTS = "get_shifts";
export const GET_SHIFTS_SUCCESS = "get_shifts_success";
